export const VERIFY_OTP_ACTION = "VERIFY_OTP_ACTION";
export const AUTO_LOGIN_ACTION = 'AUTO_LOGIN_ACTION';
export const CLEAN_LOGIN_DATA="CLEAN_LOGIN_DATA"
